import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {ConfigureEventsStep} from "./ConfigureEventsStep";
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";


class EditEventsModalClass extends Component {

    handleSave(selectedActions) {
        const url = `${API_URL}client/ad_account/${this.props.clientAdAccount.id}/selected_actions`;
        new APIClient(url).call('POST', {selected_actions: selectedActions}).then(() => {
            this.props.toggle();
            this.props.onSaved();
        });
    }

    render() {
        const {t, isOpen, toggle, clientAdAccount} = this.props;
        return (
            <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
                <ModalHeader toggle={toggle}>{t('edit_events_modal.title')}</ModalHeader>
                {isOpen && <ConfigureEventsStep
                    channel={clientAdAccount.channel}
                    adAccountDbId={clientAdAccount.ad_account_id}
                    agencyClientAdAccountId={clientAdAccount.id}
                    initialSelectedActions={clientAdAccount.selected_actions || []}
                    onSave={(actions) => this.handleSave(actions)}
                    onSkip={toggle}
                    cancelLabel={t('configure_events.cancel')}
                />}
            </Modal>
        );
    }
}

export const EditEventsModal = withTranslation()(EditEventsModalClass);
export default EditEventsModal;
